<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import Dollar from "../Components/Dollar.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { inertia, router } from "@inertiajs/svelte";

  export let cart, duplicates;

  let fees = 0;

  $: fees = Object.values(cart).reduce(
    (total, cartItem) => total + cartItem.detail.FeeTotal,
    0
  );

  function removeItem(vin) {
    router.delete(window.route("renewal.cart.delete"), {
      data: { id: vin },
      onSuccess: () => {
        router.reload();
      },
    });
  }
</script>

<PageHead>
  <svelte:fragment slot="title">Review</svelte:fragment>
  <svelte:fragment slot="tagline"
    >Please review the items you have selected for renewal. To remove an item,
    click the <i class="bi bi-trash text-danger small mx-1"></i> icon.</svelte:fragment
  >
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="search"></span>
    <span slot="cart"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <Alerts />
        <table class="table table-bordered mb-0">
          <thead class="small">
            <tr>
              <th>Description</th>
              <th>Renewal Period</th>
              <th>Amount</th>
              <th class="text-center">Remove</th>
            </tr>
          </thead>
          <tbody>
            {#each Object.entries(cart) as [id, item]}
              <tr class="align-middle">
                <td>
                  {#if duplicates.includes(id)}
                    <span class="badge text-bg-warning">Already Renewed!</span
                    >&nbsp;
                  {/if}
                  <a
                    href={window.route("renewal.detail", {
                      id: id,
                    })}
                    use:inertia
                    class="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                  >
                    {item.registration.VehicleDetail.Year}
                    {item.registration.VehicleDetail.Make}
                    {item.registration.VehicleDetail.Model}
                  </a>
                </td>
                <td>
                  {item.renewal.renewalTerm} Year Renewal
                </td>
                <td>
                  <Dollar value={item.detail.FeeTotal} />
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    on:click|once={() => removeItem(id)}
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            {/each}
          </tbody>
          <tfoot class="text-left">
            <tr>
              <th colspan="2">Total Fees:</th>
              <th colspan="2">
                <Dollar value={fees} />
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="card-footers">
        <div class="row g-2 justify-content-between mb-3 mx-2">
          <div class="col-auto col-lg-3 d-lg-grid">
            <a
              href={window.route("renewal.search")}
              use:inertia
              class="btn btn-info"
            >
              <i class="bi bi-plus"></i> Add Another Vehicle
            </a>
          </div>
          <div class="col-auto col-lg-3 d-lg-grid">
            <a
              href={window.route("renewal.reminders")}
              use:inertia
              class="btn btn-success"
              >Next <i class="bi bi-arrow-right-short"></i></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
